/* eslint-disable camelcase */
function toThousands(num) {
  return parseFloat(num)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}
// 等额本息
export const forehead = (money, period, type, month_apr) => {
  let interest_tot = 0;
  let repayment_tot = 0;
  const newArr = [];
  // eslint-disable-next-line no-restricted-properties
  const repayment = (money * month_apr * Math.pow(1 + month_apr, period))
    // eslint-disable-next-line no-restricted-properties
    / (Math.pow(1 + month_apr, period) - 1);

  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= period; i++) {
    // eslint-disable-next-line no-restricted-properties
    let capital = (money * month_apr * Math.pow(1 + month_apr, i - 1))
      // eslint-disable-next-line no-restricted-properties
      / (Math.pow(1 + month_apr, period) - 1);
    const repayment_a = repayment.toFixed(2);
    capital = capital.toFixed(2);
    const interest_a = (repayment_a - capital).toFixed(2);
    interest_tot += interest_a * 1; // 预期收益
    repayment_tot += repayment_a * 1; // 本息合计
    newArr.push({
      interest_a: toThousands(interest_a),
      capital: toThousands(capital),
      repayment_a: toThousands(repayment_a),
    });
  }
  return {
    newArr,
    interest_tot,
    repayment_tot,
  };
};
// 等本等息
export const SuchEa = (money, period, type, month_apr) => {
  let interest_tot = 0; // 预期收益
  let repayment_tot = 0; // 本息合计
  const newArr = [];
  let month_apr_new = month_apr * money;
  let money_new = money / period;
  let repayment_a = month_apr_new + money_new;
  month_apr_new = month_apr_new.toFixed(2);
  money_new = money_new.toFixed(2);
  repayment_a = repayment_a.toFixed(2);
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= period; i++) {
    interest_tot += month_apr_new * 1; // 预期收益
    repayment_tot += repayment_a * 1; // 本息合计
    newArr.push({
      interest_a: toThousands(month_apr_new),
      capital: toThousands(money_new),
      repayment_a: toThousands(repayment_a),
    });
  }
  return {
    newArr,
    interest_tot,
    repayment_tot,
  };
};

// 等额本金

export const Standard = (money, period, type, month_apr) => {
  let interest_tot = 0;
  let repayment_tot = 0;
  const newArr = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= period; i++) {
    let repayment_a = money / period + (money - ((i - 1) * money) / period) * month_apr;
    // 每月应还本金=贷款本金÷还款月数
    let capital = money / period;
    // 每月应还利息=剩余本金×月利率=(贷款本金-已归还本金累计额)×月利率
    let interest_a = repayment_a - capital;
    repayment_a = repayment_a.toFixed(2);
    capital = capital.toFixed(2);
    interest_a = interest_a.toFixed(2);

    interest_tot += interest_a * 1; // 预期收益
    repayment_tot += repayment_a * 1; // 本息合计
    newArr.push({
      interest_a: toThousands(interest_a),
      capital: toThousands(capital),
      repayment_a: toThousands(repayment_a),
    });
  }
  return {
    newArr,
    interest_tot,
    repayment_tot,
  };
};

// 每月付息一次还本
export const principalOnceMonth = (money, period, type, month_apr) => {
  let interest_tot = 0;
  let repayment_tot = 0;
  const newArr = [];
  const interest_a = (money * month_apr).toFixed(2);

  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= period; i++) {
    let capital = 0;
    let repayment_a = interest_a;
    if (i === period) {
      capital = money.toFixed(2);
      repayment_a = (interest_a * 1 + capital * 1).toFixed(2);
    }
    repayment_tot += repayment_a * 1; // 本息合计
    interest_tot += interest_a * 1; // 预期收益
    newArr.push({
      interest_a: toThousands(interest_a),
      capital: toThousands(capital),
      repayment_a: toThousands(repayment_a),
    });
  }
  return {
    newArr,
    interest_tot,
    repayment_tot,
  };
};

// eslint-disable-next-line func-names
export const DoMath = (money, period, type, month_apr) => {
  if (type === '0') {
    return forehead(money, period, type, month_apr);
  }
  if (type === '1') {
    return SuchEa(money, period, type, month_apr);
  }
  if (type === '2') {
    return Standard(money, period, type, month_apr);
  }
  if (type === '3') {
    return principalOnceMonth(money, period, type, month_apr);
  }
};
